export const aboutAction = member => ({
  type: 'ABOUT',
  member,
})
